var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0.460938H36L18 31.5109L0 0.460938H7.11H13.77L18 7.66094L22.14 0.460938H28.8Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.460938L18 31.5109L36 0.460938H28.8L18 19.0909L7.11 0.460938H0Z",
    fill: "#41B883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10999 0.460938L18 19.1809L28.8 0.460938H22.14L18 7.66094L13.77 0.460938H7.10999Z",
    fill: "#35495E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejs);
export default __webpack_public_path__ + "static/media/vuejs.d61ce065f91bcce009b3024871255b99.svg";
export { ForwardRef as ReactComponent };